import { useTranslation } from "react-i18next";

export const useDataEntryAccidentStep = () => {
  const { t } = useTranslation();

  return { t };
};
